export const ShareThisCMPS =
  "https://platform-api.sharethis.com/js/sharethis.js#property=6944b6ffe0891b98fd79a97c&product=sop"

/** 支持在线申请发票的业务线 */
export const INVOICE_SUPPORTED_APP_NAMES = ["spotoverseas", "en_meeting", "en_conference"]
